// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1tYhh","title":"FrontImage_title__6nkzy"};